import { useEffect, useState } from "react";
import { X } from "lucide-react";

export default function LeaderModal({ leader, onClose }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    document.body.style.overflow = "hidden";
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [onClose]);

  if (!leader) return null;

  return (
    <div
      data-testid="leader-modal"
      className={`fixed inset-0 z-[100] flex items-center justify-center p-4 transition-opacity duration-200 ${mounted ? "opacity-100" : "opacity-0"}`}
      onClick={onClose}
    >
      <div className="absolute inset-0" style={{ background: "rgba(15, 23, 42, 0.7)", backdropFilter: "blur(4px)" }} />
      <div
        onClick={(e) => e.stopPropagation()}
        className={`relative bg-white max-w-3xl w-full max-h-[90vh] overflow-y-auto transition-transform duration-200 ${mounted ? "translate-y-0" : "translate-y-4"}`}
      >
        <button
          onClick={onClose}
          data-testid="leader-modal-close"
          aria-label="Close"
          className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-white border border-slate-200 hover:bg-slate-900 hover:text-white hover:border-slate-900 transition-colors z-10"
        >
          <X size={18} />
        </button>

        <div className="grid md:grid-cols-12 gap-0">
          <div className="md:col-span-5 p-8 md:p-10 flex flex-col items-center text-center" style={{ background: "var(--zt-bg-muted)" }}>
            <div className="w-44 h-44 rounded-full overflow-hidden border-4 border-white shadow-lg mb-5">
              <img src={leader.image} alt={leader.name} className="w-full h-full object-cover" />
            </div>
            <h3 className="text-2xl font-bold leading-tight mb-2">{leader.name}</h3>
            <p className="text-sm font-medium" style={{ color: "var(--zt-navy)" }}>{leader.title}</p>
          </div>
          <div className="md:col-span-7 p-8 md:p-10">
            <p className="zt-overline mb-4">Full Biography</p>
            <p className="text-slate-700 leading-[1.8] text-base">{leader.bio}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
